import React from 'react'
import './card-scroll.scss'

export default function Cardscroll({children, className}) {
  return (
    <div className= {'f-cardScroll ' + className}>
      <div className="f-cardScroll__containerScroll">{children}</div>
    </div>
  )
}
